<template>
    <section class="slice slice-trends-testimonials" :class="{'slice-trends-testimonials--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <TitleBrand v-if="props.slice.primary.title" :field="props.slice.primary.title" />
            <div v-if="props.slice.primary.testimonials">
                <TrendsCarousel :items="props.slice.primary.testimonials" :breakpoints="breakpoints" :spacebetween="40">
                    <template #before>
                        <img src="/assets/svg/quotes-open.svg" width="50" class="slice-trends-testimonials__quotes-open" loading="lazy" />
                    </template>
                    <template #after>
                        <img src="/assets/svg/quotes-close.svg" width="50" class="slice-trends-testimonials__quotes-close" loading="lazy" />
                    </template>
                    <template #card="{item}">
                        <TrendsTestimonialCard
                            :testimonial="item.description"
                            :name="item.name ?? ''"
                            :job-title="item.jobTitle ?? ''"
                            :image="item.image"
                        />
                    </template>
                </TrendsCarousel>
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';
    import {getSliceComponentProps} from '@prismicio/vue';

    import TitleBrand from '~/components/TitleBrand.vue';
    import TrendsCarousel, {type TrendsCarouselBreakpoints} from '~/components/trends/TrendsCarousel.vue';
    import TrendsTestimonialCard from '~/components/trends/TrendsTestimonialCard.vue';

    // The array passed to `getSliceComponentProps` is purely optional.
    // Consider it as a visual hint for you when templating your slice.
    const props = defineProps(getSliceComponentProps<Content.TrendsTestimonialsSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);

    const breakpoints: TrendsCarouselBreakpoints = {
        0: {slidesPerView: 1.2},
        640: {slidesPerView: 1.2},
        840: {slidesPerView: 2.2},
        992: {slidesPerView: 3},
    };
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .slice-trends-testimonials {
        --quotes-position-x: 50px;

        &--grey {
            background-color: var(--joy-color-neutral-20);
        }

        .trends-carousel__buttons {
            @include mq.screen_md(min) {
                margin-top: 0 !important;
            }
        }

        .trends-card {
            max-width: unset;
        }

        .title-brand {
            text-align: center;

            @include mq.screen_md(min) {
                margin-bottom: 0;
            }
        }

        .slice-content {
            position: relative;

            @include mq.screen_md(min) {
                .swiper-slide {
                    padding: 0 0 var(--joy-core-spacing-1) 0;
                }
            }
        }

        &__quotes-open,
        &__quotes-close {
            display: none;

            @include mq.screen_md(min) {
                position: relative;
                width: 50px;
                height: 50px;
                display: block;
            }
        }

        @include mq.screen_lg(min) {
            --quotes-position-x: 25px;
        }

        @include mq.screen_xlg(min) {
            --quotes-position-x: 0px;
        }

        &__quotes-open {
            left: calc(var(--quotes-position-x) - 50px);
            margin-bottom: var(--joy-core-spacing-5);
        }

        &__quotes-close {
            left: calc(100% - var(--quotes-position-x));
            margin-top: var(--joy-core-spacing-5);
        }
    }
</style>
